/**
 * The one place in this codebase that reads `window.location`.
 *
 * `scripts/check-invariants.sh` fails the build on `location.hostname`,
 * `location.host` and `location.origin` in every other file, and exempts this
 * one by name. That is deliberate: the rule it enforces — §5b, "environment is
 * explicit in config, never inferred from hostname" — is one of the easiest to
 * break by accident and one of the most damaging when broken, so the exemption
 * is a single small file somebody can read in full rather than a pattern that
 * has to be judged case by case at review time.
 *
 * **What this module is for, and what it is not.**
 *
 * Reading our own origin is legitimate only when configuration remains the
 * authority and the origin is the thing being *checked against* it. The one
 * such case today is detecting that the configured Ory tenant is a different
 * site from the app, which makes its session cookie third-party and silently
 * undeliverable — a diagnosis, surfaced to the user, that changes no behaviour.
 *
 * It is NOT for deciding the environment, the API base, the Ory tenant, or
 * anything else that has a `TESORA_*` variable behind it. If a change wants the
 * origin in order to *choose* something, the change is wrong: the value it
 * wants belongs in the overlay's ConfigMap and in `/config.json`.
 */

/** The app's own origin, e.g. `https://staging.tesora.money`. */
export function appOrigin(): string {
  return window.location.origin
}

/** The app's own host, e.g. `staging.tesora.money`. For display only. */
export function appHost(): string {
  return window.location.host
}
